<template>
    <v-container fluid>
      <v-row align="center" justify="center" class="mx-0">
        <v-col cols="12">
          <v-card outlined>
            <v-card-title>
              <div class="text-h5">{{ event.name || "" }}</div>
            </v-card-title>
            <v-card-text v-if="cardHolders.length > 0">
              <ConnectionListDialog
                v-model="viewConnectionsDialog"
                :fullName="connectionListFullName"
                :businessCardId="connectionListBusinessCardId"
                :noOfConnections="connectionListNoOfConnections"
              />
              <v-row>
                <v-col cols="12" sm="6" md="8" class="d-flex align-center">
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    outlined
                    single-line
                    hide-details
                    rounded
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-data-table
                :headers="headers"
                :items="cardHolders"
                :items-per-page="8"
                :search="search"
                :sort-by="['name']"
              >
                <template v-slot:item.displayImageUrl="{ item }">
                  <UserAvatar
                    :key="item.businessCardId"
                    :usersInitials="item.firstName[0] + item.lastName[0]"
                    :displayImageUrl="item.displayImageUrl || ''"
                  />
                </template>
                <template v-slot:item.status="{ item }">
                  <v-chip
                    label
                    :color="
                      getStatusColor(item) +
                      '--text ' +
                      getStatusColor(item) +
                      ' lighten-5'
                    "
                    class="font-weight-medium"
                    dark
                    small
                    >{{ getStatusText(item) }}</v-chip
                  >
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-menu transition="slide-y-transition" bottom left offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on">
                        <v-icon>more_vert</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="openEditCardholderDialog(item)">
                        <v-list-item-title>{{ item.status === 'Outstanding'? 'Finalise' : 'Edit' }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item v-if="item.status !== 'Outstanding'" @click="showBusinessCardOnDevice(item)">
                        <v-list-item-title>Preview</v-list-item-title>
                      </v-list-item>
                      <!-- <v-list-item
                        @click="resendInviteBySMS(item)"
                        v-if="
                          item.status === 'Pending' || item.status === 'Declined'
                        "
                      >
                        <v-list-item-title
                          >Resend Invite by SMS</v-list-item-title
                        >
                      </v-list-item> -->
                      <v-list-item
                        @click="resendInvite(item)"
                        v-if="
                          item.status === 'Pending' || item.status === 'Declined'
                        "
                      >
                        <v-list-item-title
                          >Resend Invite by Email</v-list-item-title
                        >
                      </v-list-item>
  
                      <v-list-item
                        @click="viewConnections(item)"
                        v-if="(item.noOfConnections || 0) > 0"
                      >
                        <v-list-item-title>View Connections</v-list-item-title>
                      </v-list-item>
                      <!-- <v-list-item
                        @click="openReassignConnectionsDialog(item)"
                        v-if="item.status !='Pending' && item.status != 'Declined'"
                      >
                        <v-list-item-title>Reassign Connections</v-list-item-title>
                      </v-list-item> -->
                      <v-list-item
                        @click="openCopyConnectionsDialog(item)"
                        v-if="(item.noOfConnections || 0) > 0"
                      >
                        <v-list-item-title>Copy Connections</v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        @click="copyCardLink(item)"
                      >
                        <v-list-item-title>Copy Card Link</v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        @click="openDeactivateCardDialog(item)"
                        v-if="item.status === 'Active'"
                      >
                        <v-list-item-title>Deactivate Card</v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        @click="openCancelInvitationDialog(item)"
                        v-if="item.status === 'Pending'"
                      >
                        <v-list-item-title>Cancel Invitation</v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        @click="openRemoveCardholderDialog(item)"
                        v-if="item.status === 'Outstanding'"
                      >
                        <v-list-item-title>Remove</v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        @click="resendInvite(item)"
                        v-if="item.status === 'Deactivated'"
                      >
                        <v-list-item-title>Reactivate Card</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-text v-else>
              <v-sheet height="300" tile>
                <v-row class="fill-height" align="center" justify="center">
                  <v-card elevation="0">
                    <v-card-text
                      v-if="
                        currentPermission.privilegeLevel == 'admin' ||
                        currentPermission.privilegeLevel == 'editor'
                      "
                    >
                      <template
                        v-if="
                          businessProfile.isBusinessCardDesignAdded == false ||
                          businessProfile.isBusinessCardInformationAdded == false
                        "
                      >
                        <RequiresOnboarding />
                      </template>
                      <template v-else>
                        <div class="text-center">
                          <v-icon color="grey lighten-2" size="85"
                            >mdi-account-plus</v-icon
                          >
                        </div>
                        <div
                          class="
                            mt-2
                            text-center text--primary text-h6
                            font-weight-regular
                          "
                        >
                          Add Team Members
                        </div>
                        <div class="text-center">
                          Add your first team member by clicking the button below.
                        </div>
                        <div class="text-center my-4">
                          <v-btn
                            class="pa-5"
                            color="primary"
                            elevation="0"
                            @click="openNewCardholderDialog"
                            width="220"
                          >
                            <v-icon left>add</v-icon> Add New
                          </v-btn>
                          <template
                            v-if="
                              businessProfile.noOfEmployees - noOfCardHolders >=
                              10
                            "
                          >
                            <span class="mx-4">Or</span>
                            <v-btn
                              width="220"
                              class="pa-5"
                              color="primary"
                              elevation="0"
                              @click="sendRequestDialog = true"
                            >
                              Need a Bulk Upload?
                            </v-btn>
                            <SendRequestDialog
                              requestType="BULK_UPLOAD"
                              :showDialog="sendRequestDialog"
                              @canceled="sendRequestDialog = false"
                            />
                          </template>
                        </div>
                      </template>
                    </v-card-text>
                    <v-card-text v-else>
                      <div class="text-center">
                        <v-icon color="grey lighten-2" size="85"
                          >mdi-account-remove</v-icon
                        >
                      </div>
                      <div
                        class="
                          mt-2
                          text-center text--primary text-h6
                          font-weight-regular
                        "
                      >
                        No Team Members
                      </div>
                      <div class="text-center">
                        There are no team members to display.
                      </div>
                    </v-card-text>
                  </v-card>
                </v-row>
              </v-sheet>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!--Start: Business Card on device dialog-->
      <v-dialog
        v-model="businessCardOnDeviceDialog"
        width="300"
        content-class="device-corners"
      >
        <BusinessCardOnDevice
          :title="deviceTitle"
          :subtitle="deviceSubtitle"
          :line1="deviceLine1"
          :line2="deviceLine2"
          :line3="deviceLine3"
          :qualification="qualification"
        />
      </v-dialog>
      <!--End: Business Card on device dialog -->
      <v-form ref="form" v-model="valid">
        <v-dialog
          v-model="editAddDialog"
          max-width="800px"
          persistent
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
        >
          <v-card>
            <v-toolbar dark :class="{ secondary: !$vuetify.theme.dark }">
              <v-btn icon dark @click="closeAddEditCardholderDialog">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>{{ addEditDialogTitle }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn dark text v-on:saved="dialog = false" @click="onSave">
                  <template v-if="addEditDialogState == 'add' || addEditDialogState == 'finalise'">
                    <v-icon class="mr-2">mdi-send mdi-rotate-315</v-icon> Issue Card
                  </template>
                  <template v-else>
                    <v-icon class="mr-2">save</v-icon> Save
                  </template>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-card-text class="mt-5">
              <v-row>
                <v-col cols="12" md="8" lg="6">
                  <v-row>
                    <v-col cols="12" md="6" xl="4" class="my-0 py-0">
                      <v-text-field
                        :validate-on-blur="isFirstSubmissionAttempt"
                        :rules="nameRules"
                        label="First Name"
                        required
                        outlined
                        dense
                        v-model="cardholder.firstName"
                        class="text-transform-capitalize"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" xl="4" class="my-0 py-0">
                      <v-text-field
                        :validate-on-blur="isFirstSubmissionAttempt"
                        :rules="nameRules"
                        label="Last Name"
                        required
                        outlined
                        dense
                        v-model="cardholder.lastName"
                        class="text-transform-capitalize"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4" md="2" xl="1" class="my-0 py-0">
                      <v-autocomplete
                        v-model="selectedTelephoneCode"
                        label="Country"
                        required
                        outlined
                        dense
                        :items="telephoneCodes"
                        item-text="countryCode"
                        item-value="countryCode"
                        return-object
                        :filter="filterTelephoneCodeAutocompleteBox"
                      >
                        <template slot="item" slot-scope="data">
                          {{ data.item.name }} ({{ data.item.countryCode }})
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="8" md="4" xl="3" class="my-0 py-0">
                      <v-text-field
                        :prefix="selectedTelephoneCode.number"
                        placeholder=" "
                        :validate-on-blur="isFirstSubmissionAttempt"
                        v-mask="mobileMask"
                        :rules="mobileRules"
                        label="Mobile"
                        required
                        outlined
                        dense
                        v-model="cardholder.mobile"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" xl="4" class="my-0 py-0">
                      <v-text-field
                        :validate-on-blur="isFirstSubmissionAttempt"
                        label="Email"
                        required
                        outlined
                        dense
                        v-model="cardholder.email"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" xl="8" class="my-0 py-0">
                      <v-text-field
                        :validate-on-blur="isFirstSubmissionAttempt"
                        :rules="nameRules"
                        label="Job Title"
                        required
                        outlined
                        dense
                        v-model="cardholder.jobTitle"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" xl="12" class="my-0 py-0 mb-5">
                      <div class="text-body-1 text--primary font-weight-medium">
                        Individual Team Member Permissions
                      </div>
                      <div class="text-body-2">
                        Turn toggle/radio buttons On or Off to enable your team
                        member to attach additional information to their business
                        card. When ready, click Issue Card button in the top right
                        hand corner of your screen to issue the business card to
                        your team member.
                      </div>
                    </v-col>
                    <v-col cols="12" sm="12" xl="12" class="my-0 py-0">
                      <v-switch
                        class="my-0 py-1"
                        label="Disable card sharing"
                        v-model="cardholder.disableCardSharing"
                      ></v-switch>
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="
                      addEditDialogState == 'add' ||
                      cardholder.status == 'Pending' ||
                      addEditDialogState == 'finalise'
                    "
                  >
                    <v-col cols="12" sm="12" xl="12" class="my-0 py-0">
                      <v-switch
                        class="my-0 py-1"
                        label="Auto-connect to all other team members on card acceptance"
                        v-model="cardholder.autoConnectToOthers"
                      ></v-switch>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" xl="12" class="my-0 py-0">
                      <v-switch
                        class="my-0 py-1"
                        label="Enable this team member to add their LinkedIn Handle"
                        v-model="cardholder.permissions.linkedin"
                      ></v-switch>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" xl="12" class="my-0 py-0">
                      <v-switch
                        class="my-0 py-1"
                        label="Enable this team member to add Qualifications and Professional Organisation Accreditation"
                        v-model="cardholder.permissions.qualifications"
                      ></v-switch>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" xl="12" class="my-0 py-0">
                      <v-switch
                        class="my-0 py-1"
                        label="Enable this team member to add their own Facebook URL"
                        v-model="cardholder.permissions.facebook"
                      ></v-switch>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" xl="12" class="my-0 py-0">
                      <v-switch
                        class="my-0 py-1"
                        label="Enable this team member to add their own Instagram Handle"
                        v-model="cardholder.permissions.instagram"
                      ></v-switch>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" xl="12" class="my-0 py-0">
                      <v-switch
                        class="my-0 py-1"
                        label="Enable this team member to add their own Twitter Handle"
                        v-model="cardholder.permissions.twitter"
                      ></v-switch>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" xl="12" class="my-0 py-0">
                      <v-switch
                        class="my-0 py-1"
                        label="Enable this team member to add an additional address"
                        v-model="cardholder.permissions.address"
                      ></v-switch>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" xl="12" class="my-0 py-0">
                      <v-switch
                        class="my-0 py-1"
                        label="Enable this team member to add an additional URL"
                        v-model="cardholder.permissions.additionalWebsite"
                      ></v-switch>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" xl="12" class="my-0 py-0">
                      <v-switch
                        class="my-0 py-1"
                        label="Enable this team member to add an additional phone number"
                        v-model="cardholder.permissions.additionalPhoneNumber"
                      ></v-switch>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" xl="12" class="my-0 py-0">
                      <v-switch
                        class="my-0 py-1"
                        label="Enable this team member to add an additional email address"
                        v-model="cardholder.permissions.additionalEmail"
                      ></v-switch>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-form>
      <v-dialog v-model="loadingDialog" persistent width="400">
        <v-card color="primary" dark>
          <v-card-text>
            {{ loadingMessage }}
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="errorDialog" max-width="380">
        <v-card>
          <v-card-title class="headline">{{
            errorMessageTitle == "" ? "Error" : errorMessageTitle
          }}</v-card-title>
          <v-card-text>
            {{ errorMessage }}
            <v-btn
              class="mt-10 text-body-1"
              block
              color="primary"
              large
              elevation="0"
              @click="errorDialog = false"
              >Okay</v-btn
            >
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="copyConnectionsDialog" max-width="400" scrollable>
        <v-card>
          <v-card-title class="headline">Select Team Member</v-card-title>
          <v-card-subtitle class="mt-1">
            Please select the team member to whom you intend to copy these
            connections.
          </v-card-subtitle>
          <v-card-text>
            <v-text-field
              v-model="copyConnectionSearch"
              append-icon="mdi-magnify"
              label="Search"
              outlined
              single-line
              hide-details
              rounded
              dense
            ></v-text-field>
            <v-list nav>
              <template v-for="item in filteredCopyConnectionsItems">
                <v-list-item
                  v-if="(item.businessCardId || '') != businessCardId"
                  :key="item.businessCardId"
                  @click="copyConnetions(item)"
                >
                  <UserAvatar
                    :key="item.businessCardId"
                    :usersInitials="item.firstName[0] + item.lastName[0]"
                    :displayImageUrl="item.displayImageUrl || ''"
                  />
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">{{
                      item.name
                    }}</v-list-item-title>
                    <v-list-item-subtitle>{{ item.email }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="deactivateDialog" max-width="400">
        <v-card>
          <v-card-title class="headline">Deactivate Card</v-card-title>
          <v-card-text>
            <p class="text-subtitle-1">
              If you continue, this Card and its linked Connections will be
              deactivated. You can reactivate this card at any time.
            </p>
            <p class="text-subtitle-1">
              The team member will be notified inside their Pappyon app, that they
              no longer have access to this Card and will have a 5 day timeframe
              to confirm whether they wish to retain access to their connections.
            </p>
            <v-btn
              class="mt-10 text-body-1"
              large
              elevation="0"
              color="primary"
              block
              @click="deactivateCardholder"
            >
              Deactivate Card
            </v-btn>
  
            <v-btn
              class="mt-2 text-body-1"
              large
              text
              elevation="0"
              color="primary"
              block
              @click="deactivateDialog = false"
            >
              Cancel
            </v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="cancelInvitationDialog" max-width="400">
        <v-card>
          <v-card-title class="headline">Cancel Invitation</v-card-title>
          <v-card-text>
            <p class="text-subtitle-1">
              Are you sure you want to cancel this invitation?
            </p>
            <v-btn
              class="mt-10 text-body-1"
              large
              elevation="0"
              color="primary"
              block
              @click="cancelInvitation"
            >
              Yes
            </v-btn>
  
            <v-btn
              class="mt-2 text-body-1"
              large
              text
              elevation="0"
              color="primary"
              block
              @click="cancelInvitationDialog = false"
            >
              No
            </v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="removeCardholderDialog" max-width="400">
        <v-card>
          <v-card-title class="headline">Remove Team Member</v-card-title>
          <v-card-text>
            <p class="text-subtitle-1">
              Are you sure you want to remove this team member?
            </p>
            <v-btn
              class="mt-10 text-body-1"
              large
              elevation="0"
              color="primary"
              block
              @click="removeCardholder"
            >
              Yes
            </v-btn>
  
            <v-btn
              class="mt-2 text-body-1"
              large
              text
              elevation="0"
              color="primary"
              block
              @click="removeCardholderDialog = false"
            >
              No
            </v-btn>
          </v-card-text>
        </v-card>
        </v-dialog>
      <v-snackbar v-model="snackbar" left multi-line :timeout="snackbarTimeout">
        {{ snackbarText }}
  
        <template v-slot:action="{ attrs }">
          <v-btn
            color="primary"
            text
            v-bind="attrs"
            @click="snackbar = false"
            top
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>
      <v-dialog v-model="subscriptionLimitReachedDialog" width="400">
        <v-tabs-items
          class="transparent"
          v-model="subscriptionLimitReachedDialogTabIndex"
          align-center
          justify-center
        >
          <v-tab-item>
            <v-card>
              <v-card-title> Subscription Limit Reached </v-card-title>
              <v-card-text>
                <p class="text-subtitle-1">
                  Whoops! It looks like you have tried to add more team members
                  than your current subscription allows. Please increase your
                  subscription limit below to continue.
                </p>
                <v-btn
                  class="mt-10 text-body-1"
                  block
                  color="primary"
                  large
                  elevation="0"
                  @click="subscriptionLimitReachedDialogTabIndex = 1"
                  >Upgrade Subscription</v-btn
                >
                <v-btn
                  block
                  text
                  color="primary"
                  large
                  class="mt-2 text-body-1"
                  @click="subscriptionLimitReachedDialog = false"
                  >Cancel</v-btn
                >
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <UpdateCardholderLimitCard
              :initialize="subscriptionLimitReachedDialog"
              @canceled="subscriptionLimitReachedDialog = false"
            />
          </v-tab-item>
        </v-tabs-items>
      </v-dialog>
    </v-container>
  </template>
  <script>
  import { mapGetters, mapActions } from "vuex";

  import BusinessCardOnDevice from "@/components/BusinessCardOnDevice";
  import Utility from "@/shared/utility";
  import UpdateCardholderLimitCard from "@/components/UpdateCardholderLimitCard";
  import UserAvatar from "@/components/UserAvatar";
  import SendRequestDialog from "@/components/SendRequestDialog";
  import ConnectionListDialog from "@/components/ConnectionListDialog";
  import RequiresOnboarding from "@/components/RequiresOnboarding";
  import PulsatingAnimation from "@/components/PulsatingAnimation";
  import EventTrigger from "@/models/EventTrigger";
  import constants from "@/shared/constants";
  import Event from "@/models/Event";
  import {
    businessCardsCollectionRef,
    businessCardsDocRef,
    businessPortalStatsDocRef,
    getEventDoc,
    getHttpsCallable,
    getNewDocRefByCollectionName,
    getNewDocRefByCollectionRef,
    getQueryUsersCollection,
    updateBusinessCardsDoc
  } from "@/shared/firebase_utils";
  import { increment, getFirestore, where, writeBatch} from "firebase/firestore";
  
  export default {
    name: "manageCardholders",
    components: {
      BusinessCardOnDevice,
      UpdateCardholderLimitCard,
      UserAvatar,
      SendRequestDialog,
      ConnectionListDialog,
      RequiresOnboarding,
      PulsatingAnimation,
    },
    watch: {
      subscriptionLimitReachedDialog: function (newVal, oldVal) {
        if (newVal == false) this.subscriptionLimitReachedDialogTabIndex = 0;
      },
    },
    created() {
      this.getUsersFullName = Utility.getUsersFullName;
      this.retrieveEvent();
    },
  
    data() {
      return {
        event: null,
        businessCardId: "",
        sendRequestDialog: false,
        cancelInvitationDialog: false,
        removeCardholderDialog: false,
        subscriptionLimitReachedDialogTabIndex: 0,
        errorMessageTitle: "",
        businessCardOnDeviceDialog: false,
        subscriptionLimitReachedDialog: false,
        isFirstSubmissionAttempt: true,
        valid: false,
        nameRules: [(v) => !!v || "This field is required"],
        mobileRules: [
          (v) => !!v || "This field is required",
          (v) => /^\d+$/.test(v.replaceAll(" ", "")) || "Invalid mobile number",
        ],
        selectedTelephoneCode: {
          name: "Australia",
          number: "+61",
          countryCode: "AU",
        },
        search: "",
        copyConnectionSearch: "",
        editAddDialog: false,
        addEditDialogTitle: "",
        addEditDialogState: "edit",
        loadingDialog: false,
        errorDialog: false,
        errorMessage: "",
        loadingMessage: "",
        snackbar: false,
        snackbarText: "",
        snackbarTimeout: 5000,
        deactivateDialog: false,
        copyConnectionsDialog: false,
        cardholder: {
          firstName: "",
          lastName: "",
          email: "",
          mobile: "",
          jobTitle: "",
          permissions: {
            linkedin: false,
            qualifications: false,
            facebook: false,
            instagram: false,
            twitter: false,
            address: false,
            additionalWebsite: false,
            additionalPhoneNumber: false,
            additionalEmail: false,
            disableCardSharing: false,
            autoConnectToOthers: false,
          },
        },
        deviceTitle: "",
        deviceSubtitle: "",
        deviceLine1: "",
        deviceLine2: "",
        deviceLine3: "",
        viewConnectionsDialog: false,
        connectionListFullName: "",
        connectionListBusinessCardId: "",
        connectionListNoOfConnections: "",
        hideIssueCardTooltip: false,
        qualification: "",
        cardIssuedReminders: [],
        cardHolderItem: {},
      };
    },
    computed: {
      filteredCopyConnectionsItems() {
        return this.cardHolders.filter((item) => {
          return (
            (item.status == "Active" || item.status == "Pending") &&
            (this.copyConnectionSearch == "" ||
              item.name
                .toLowerCase()
                .includes(this.copyConnectionSearch.toLowerCase()) ||
              item.email
                .toLowerCase()
                .includes(this.copyConnectionSearch.toLowerCase()))
          );
        });
      },
      mobileMask() {
        if (this.selectedTelephoneCode.countryCode == "AU")
          return "W## ### ######";
        else return "### ### ######";
      },
      ...mapGetters([
        "userProfile",
        "telephoneCodes",
        "businessProfile",
        "cardHolders",
        "noOfCardHolders",
        "currentPermission",
        "noOfCardHoldersCreatedInBusinessPortal",
      ]),
  
      headers() {
        let headerElements = [
          {
            text: "",
            align: "right",
            value: "displayImageUrl",
            sortable: false,
          },
          {
            text: "Name",
            align: "start",
            value: "name",
          },
          { text: "Email", value: "email" },
          // { text: "Card Issue", value: "cardIssue" },
          // { text: 'Connections', value: 'noOfConnections' },
          { text: "Status", value: "status", align: "center" },
        ];
        // if (
        //   this.currentPermission.privilegeLevel == "admin" ||
        //   this.currentPermission.privilegeLevel == "editor"
        // ) {
        //   headerElements.push({
        //     text: "Actions",
        //     value: "actions",
        //     align: "center",
        //   });
        // }
        return headerElements;
      },
  
      domainUriPrefix() {
        return process.env.NODE_ENV == "production"
          ? "https://card.pappyon.com"
          : "https://pappyonstaging.page.link";
      },
      webAppLinkPrefix() {
        return process.env.NODE_ENV == "production"
          ? "https://app.pappyon.com/businessCard/"
          : "https://app-staging-pappyon.web.app/businessCard/";
      },
      androidPackageName() {
        return process.env.NODE_ENV == "production"
          ? "com.pappyon.app"
          : "com.pappyon.app.dev";
      },
      iOSBundleId() {
        return process.env.NODE_ENV == "production"
          ? "com.pappyon.app"
          : "com.pappyon.app.dev";
      },
      firebaseWebAPIKey() {
        return process.env.NODE_ENV == "production"
          ? "AIzaSyCtZC_Sg48yt07uF8UgOtvfmtH41ECKaCM"
          : "AIzaSyC3T43-Es6RF5w_c-roI_Zc_2hO5NQxv3A";
      },
      showIssueCardTooltip() {
        let show = false;
        //Hide tooltip if user has clicked on "x" button
        if (this.hideIssueCardTooltip) return false;
  
        if (
          this.businessProfile.isAddNewBusinessCardTooltipDisplayed != true &&
          this.noOfCardHoldersCreatedInBusinessPortal == 0
        )
          show = true;
  
        return show;
      },
    },
    methods: {
      ...mapActions(["updateBusinessProfileDetails", "showSnackbar"]),
      getStatusText(item) {
        if (this.event.attendees.map((attendee) => attendee.businessCardId).includes(item.businessCardId))
          return 'Joined'
        else 
        if (item.status == 'Outstanding' || item.status == 'Pending') return 'Pending Invitation';
        else if (item.status == 'Active') return 'Invited';
        else return item.status;
      },
      async retrieveEvent() {
            try{
                //Get the document idea from the url parameter
                const docId = this.$route.params.eventId;
                if (docId) {

                    const docSnapshot = await getEventDoc(docId);
                    if (docSnapshot.exists) {
                        this.event = Event.fromFireStore(docSnapshot); // Convert to Event model
                        console.log("Event retrieved:", this.event.name);
                    }
                }   
            } catch (error) {
                console.log("Error in retrieveEvent:", error);
            }
        },
      viewConnections(item) {
        // this.connectionListFullName = this.getUsersFullName({
        //   firstName: item.firstName || "",
        //   lastName: item.lastName || "",
        // });
        // this.connectionListBusinessCardId = item.businessCardId;
        // this.connectionListNoOfConnections = item.noOfConnections || 0;
        // this.viewConnectionsDialog = true;
  
        this.$router.push({
          name: "connectionList",
          params: { businessCardId: item.businessCardId },
        });
      },
      async copyConnetions(item) {
        try {
          this.copyConnectionsDialog = false;
          //Start: Call a cloud function to copy the connection to the selected card
          this.loadingMessage = `Copying Connections`;
          this.loadingDialog = true;
          const copyConnections = getHttpsCallable("copyConnections");
          let result = await copyConnections({
            businessCardId1: this.businessCardId,
            businessCardId2: item.businessCardId,
          });
          //The cloud function was executed
          if (result.data.errorInfo) {
            //Encountered an error
            console.log("In the client copyConnetions then error block");
            console.log("Error: " + result.data.errorInfo.message);
            this.loadingDialog = false;
          } else {
            console.log(result.data);
            this.loadingDialog = false;
            this.snackbarText = "Connections copied successfully";
            this.snackbarTimeout = 5000;
            this.snackbar = true;
          }
          //End: Call a cloud function to copy the connection to the selected card
        } catch (error) {
          console.log(error);
        }
      },
      // capitaliseFirstName() {
      //   var splitStr = this.cardholder.firstName.split(" ");
      //   for (var i = 0; i < splitStr.length; i++) {
      //     splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      //   }
      //   this.cardholder.firstName = splitStr.join(" ");
      // },
      // capitaliseLastName() {
      //   var splitStr = this.cardholder.lastName.split(" ");
      //   for (var i = 0; i < splitStr.length; i++) {
      //     splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      //   }
      //   this.cardholder.lastName = splitStr.join(" ");
      // },
      showBusinessCardOnDevice(businessCard) {
        this.deviceTitle = this.getUsersFullName({
          firstName: businessCard.firstName || "",
          lastName: businessCard.lastName || "",
        });
        this.deviceSubtitle = businessCard.jobTitle || "";
  
        if (
          businessCard.permissions.qualifications &&
          businessCard.qualification != ""
        )
          this.qualification = businessCard.qualification;
  
        let mobileNumber = "";
        mobileNumber = businessCard.mobile || "";
        if (mobileNumber != "") {
          mobileNumber =
            (businessCard.countryPhoneCodeNumber || "") + " " + mobileNumber;
        }
        this.deviceLine1 = mobileNumber;
        this.deviceLine2 = businessCard.email || "";
        this.deviceLine3 = this.businessProfile.websiteURL || "";
        this.businessCardOnDeviceDialog = true;
      },
  
      filterTelephoneCodeAutocompleteBox(item, queryText, itemText) {
        if (
          item.name.toUpperCase().includes(queryText.toUpperCase()) ||
          itemText.toUpperCase().includes(queryText.toUpperCase())
        )
          return true;
        else return false;
      },
  
      formatDate(date) {
        var dd = String(date.getDate()).padStart(2, "0");
        var mm = String(date.getMonth() + 1).padStart(2, "0"); //January is 0!
        var yyyy = date.getFullYear();
        return dd + "/" + mm + "/" + yyyy;
      },
  
      getStatusColor(item) {
        const status = this.getStatusText(item);
        if (status == "Joined") return "green";
        else if (status == "Pending Invitation") return "orange";
        else if (status == "Invited") return "orange";
        else return "red";
      },
  
      openEditCardholderDialog(item) {
        this.cardHolderItem = item;
  
        this.businessCardId = item.businessCardId;
        this.cardholder.firstName = item.firstName || "";
        this.cardholder.lastName = item.lastName || "";
        this.cardholder.email = item.email || "";
        this.cardholder.mobile = item.mobile || "";
        this.cardholder.mobile = this.$options.filters.VMask(
          this.cardholder.mobile,
          "### ### ######"
        );
        this.cardholder.jobTitle = item.jobTitle || "";
        this.cardholder.disableCardSharing = item.disableCardSharing || false;
        this.cardholder.autoConnectToOthers = item.autoConnectToOthers || false;
        this.cardholder.status = item.status || "";
        if (item.countryPhoneCode || "" != "") {
          this.selectedTelephoneCode = {
            number: item.countryPhoneCodeNumber,
            countryCode: item.countryPhoneCode,
          };
        } else {
          this.selectedTelephoneCode = {
            name: "Australia",
            number: "+61",
            countryCode: "AU",
          };
        }
  
        this.cardholder.permissions.linkedin = false;
        this.cardholder.permissions.qualifications = false;
        this.cardholder.permissions.facebook = false;
        this.cardholder.permissions.instagram = false;
        this.cardholder.permissions.twitter = false;
        this.cardholder.permissions.address = false;
        this.cardholder.permissions.additionalWebsite = false;
        this.cardholder.permissions.additionalPhoneNumber = false;
        this.cardholder.permissions.additionalEmail = false;
  
        if (item.permissions != undefined) {
          this.cardholder.permissions.linkedin =
            item.permissions.linkedin || false;
          this.cardholder.permissions.qualifications =
            item.permissions.qualifications || false;
          this.cardholder.permissions.facebook =
            item.permissions.facebook || false;
          this.cardholder.permissions.instagram =
            item.permissions.instagram || false;
          this.cardholder.permissions.twitter = item.permissions.twitter || false;
          this.cardholder.permissions.address = item.permissions.address || false;
          this.cardholder.permissions.additionalWebsite =
            item.permissions.additionalWebsite || false;
          this.cardholder.permissions.additionalPhoneNumber =
            item.permissions.additionalPhoneNumber || false;
          this.cardholder.permissions.additionalEmail =
            item.permissions.additionalEmail || false;
        }
  
        this.addEditDialogTitle = item.status === 'Outstanding'? 'Finalise Team Member Details' : "Edit Team Member";
        this.addEditDialogState = item.status === 'Outstanding'? "finalise" : "edit";
        this.editAddDialog = true;
      },
  
      openReassignConnectionsDialog(item) {
        this.errorMessageTitle = "No connections to reassign";
        this.errorMessage = "The team member has no connections to be reassigned";
        this.errorDialog = true;
      },
      openDeactivateCardDialog(item) {
        this.businessCardId = item.businessCardId;
  
        this.deactivateDialog = true;
      },
      openCopyConnectionsDialog(item) {
        this.businessCardId = item.businessCardId;
        this.copyConnectionsDialog = true;
      },
      copyCardLink(item) {
        let link = '';
        let imageLink = item.displayImageUrl ? item.displayImageUrl : '';
        if (item.dynamicLink && (item.dynamicLink.includes('card') || item.dynamicLink.includes('page'))) {
          link = this.$appHostUrl + `/businessCard/${item.businessCardId}/?name=${item.name}&image=${imageLink}`;
        } else {
          link = item.dynamicLink;
        }
        Utility.copyToClipboard(encodeURI(link));
        this.snackbarText = "Copied to clipboard";
        this.snackbarTimeout = 5000;
        this.snackbar = true;
      },
      openCancelInvitationDialog(item) {
        this.businessCardId = item.businessCardId;
        this.cancelInvitationDialog = true;
      },
      openRemoveCardholderDialog(item) {
        this.businessCardId = item.businessCardId;
        this.removeCardholderDialog = true;
      },
      closeAddEditCardholderDialog() {
        this.editAddDialog = false;
        this.$refs.form.resetValidation();
      },
      openNewCardholderDialog() {
        if (this.noOfCardHolders >= this.businessProfile.noOfEmployees) {
          this.subscriptionLimitReachedDialog = true;
          return;
        }
  
        //Hide tooltip
        this.hideIssueCardTooltip = true;
        this.updateBusinessProfileDetails({
          isAddNewBusinessCardTooltipDisplayed: true,
        });
  
        this.businessCardId = "";
        this.cardholder.firstName = "";
        this.cardholder.lastName = "";
        this.cardholder.email = "";
        this.cardholder.mobile = "";
        this.cardholder.jobTitle = "";
        this.selectedTelephoneCode = {
          name: "Australia",
          number: "+61",
          countryCode: "AU",
        };
  
        this.cardholder.permissions.linkedin = false;
        this.cardholder.permissions.qualifications = false;
        this.cardholder.permissions.facebook = false;
        this.cardholder.permissions.instagram = false;
        this.cardholder.permissions.twitter = false;
        this.cardholder.permissions.address = false;
        this.cardholder.permissions.additionalWebsite = false;
        this.cardholder.permissions.additionalPhoneNumber = false;
        this.cardholder.permissions.additionalEmail = false;
        this.cardholder.disableCardSharing = false;
        this.cardholder.autoConnectToOthers = true;
  
        this.addEditDialogTitle = "Add New Team Member";
        this.addEditDialogState = "add";
  
        this.editAddDialog = true;
      },
  
      onSave() {
        if (this.$refs.form.validate()) {
          this.cardholder.mobile.replaceAll(" ", "");
          if (this.businessCardId === "" || this.cardholder.status === 'Outstanding') this.addNewCardholder();
          else this.editCardholder();
        }
      },
  
      async addNewCardholder() {
        try {
          this.loadingMessage = `Creating a new business card for ${this.cardholder.firstName}`;
          this.loadingDialog = true;

          const db = getFirestore();
          const batch = writeBatch(db);
          //Create a new business card document in firestore
          let businessCardDocRef = getNewDocRefByCollectionRef(businessCardsCollectionRef);

          //Initialise trigger documents
          this.createCardIssuedReminderTriggers(businessCardDocRef.id);
  
          //If the status of the cardholder is "Outstanding" then delete the firestore document.
          if(this.cardholder.status === 'Outstanding') {
            batch.delete(businessCardsDocRef(this.businessCardId));
          }

          const name = `${this.cardholder.firstName} ${this.cardholder.lastName}`;
          const link = `${this.webAppLinkPrefix}${businessCardDocRef.id}?name=${name}`;
          this.cardholder.dynamicLink = link;
          this.cardholder.dynamicLinkForAppDownload = link;
          let newBusinessCardData = {
            ...this.cardholder,
            businessProfileId: this.userProfile.businessProfileId,
            subscriptionType: "GROW",
            countryPhoneCode: this.selectedTelephoneCode.countryCode,
            countryPhoneCodeNumber: this.selectedTelephoneCode.number,
            businessName: this.businessProfile.businessName,
            noOfConnections: 0,
            creationDate: new Date(),
            status: "Pending",
            dynamicLink: this.cardholder.dynamicLink,
            qrCodeImageURL: this.businessProfile?.qrCodeImageURL || "",
          };
  
          if (this.businessProfile.partnerRepresentativeToken && this.businessProfile.partnerRepresentativeParentEventId) {
            newBusinessCardData.partnerRepresentativeToken = this.businessProfile.partnerRepresentativeToken;
            newBusinessCardData.partnerRepresentativeParentEventId = this.businessProfile.partnerRepresentativeParentEventId;
          }
  
          batch.set(businessCardDocRef, newBusinessCardData);
          batch.update(
              businessPortalStatsDocRef(this.userProfile.businessProfileId),
            {
              noOfCardholders: increment(1),
            }
          );
  
          //Start: If a user account with the given email already exists then attach the business card to this account
          let userSnapshot = await getQueryUsersCollection(where("email", "==", this.cardholder.email));
          if (userSnapshot.docs.length > 0) {
            let uid = userSnapshot.docs[0].id;
            batch.update(
              businessCardsDocRef(businessCardDocRef.id),
              { uid: uid }
            );
          }
  
          //Start: Save new trigger documents
          this.cardIssuedReminders.forEach((document) => {
            let docRef = getNewDocRefByCollectionName("triggers");
            batch.set(docRef, document.toFireStore());
          });
          //End: set and update trigger
  
          //End: If a user account with the given email already exists then attach the business card to this account
          await batch.commit();
  
          //Start: Send an invitation
          this.loadingMessage = `Sending ${this.cardholder.firstName} an invitation`;
          let businessCardUrl = this.cardholder.dynamicLink || "";
          businessCardUrl = businessCardUrl.replace("https://", "");
  
          let functionData = {
            email: this.cardholder.email,
            firstName: this.cardholder.firstName,
            businessName: this.businessProfile.businessName,
            businessCardUrl:  businessCardUrl,
          }
  
          const sendInvitation = getHttpsCallable("sendInvitation");
          let result = await sendInvitation(functionData);
          // //The cloud function was executed
          //End: Send an invitation
  
          //Start: Send an invitation to the cardholder via SMS
          // console.log(
          //   "this.cardholder.countryPhoneCodeNumber: ",
          //   this.selectedTelephoneCode.number
          // );
          // const sendInvitationToNewCardholderBySMS = firebase
          //   .functions()
          //   .httpsCallable("sendInvitationToNewCardholderBySMS");
          // let result = await sendInvitationToNewCardholderBySMS({
          //   email: this.cardholder.email,
          //   firstName: this.cardholder.firstName,
          //   businessName: this.businessProfile.businessName,
          //   businessCardUrl: this.cardholder.dynamicLinkForAppDownload || "",
          //   countryPhoneCodeNumber: this.selectedTelephoneCode.number,
          //   mobile: this.cardholder.mobile,
          // });
          //The cloud function was executed
  
          //Close the dialogs
          this.loadingDialog = false;
          this.editAddDialog = false;
  
          console.log("result: ", result);
  
          //Show snackbar
          let snackbarText =
            result.data == "The email was sent successfully"
              ? "Invitation sent successfully!"
              : "Something went wrong, please try again";
  
          this.showSnackbar({ show: true, text: snackbarText });
          //End: Send an invitation to the cardholder via SMS
        } catch (error) {
          console.log("In the client catch 4");
          console.log(error.message);
          this.loadingDialog = false;
          this.editAddDialog = false;
        }
      },
      async editCardholder() {
        console.log("edit cardholder ");

          updateBusinessCardsDoc(this.businessCardId,{
            ...this.cardholder,
            countryPhoneCode: this.selectedTelephoneCode.countryCode,
            countryPhoneCodeNumber: this.selectedTelephoneCode.number,
          })
          .then(async () => {
            this.editAddDialog = false;
  
            //Start: Update card holder's email
            let userSnapshot = await getQueryUsersCollection(where("email", "==", this.cardholder.email));
            let uid = "";
            if (userSnapshot.docs.length > 0) {
              uid = userSnapshot.docs[0].id;
            }

            await updateBusinessCardsDoc(this.businessCardId, { uid: uid });
            //End: Update card holder's email
  
            //Resend invite by email
            this.resendInvite({
              businessCardId: this.businessCardId,
              ...this.cardholder,
              dynamicLinkForAppDownload:
                this.cardHolderItem.dynamicLinkForAppDownload,
            });
          });
      },
  
      async updateCardholderStatus(status) {
        const db = getFirestore();
        const batch = writeBatch(db);
        const businessCardRef = businessCardsDocRef(this.businessCardId);
        batch.update(businessCardRef, {
          status: status,
        });
        if (status == "Active")
          batch.update(
            businessPortalStatsDocRef(this.userProfile.businessProfileId),
            {
              noOfCardholders: increment(1),
            }
          );
        if (status == "Deactivated")
          batch.update(
              businessPortalStatsDocRef(this.userProfile.businessProfileId),
            {
              noOfCardholders: increment(-1),
            }
          );
        await batch.commit();
      },
      async deleteCardholder() {
        const db = getFirestore();
        const batch = writeBatch(db);
        const businessCardRef = businessCardsDocRef(this.businessCardId);
        batch.delete(businessCardRef);
        batch.update(
            businessPortalStatsDocRef(this.userProfile.businessProfileId),
          {
            noOfCardholders: increment(-1),
          }
        );
        await batch.commit();
      },
      async deactivateCardholder() {
        try {
          this.deactivateDialog = false;
          //Start: Call a cloud function to deactivate to the selected card
          this.loadingMessage = `Deactivating business card...`;
          this.loadingDialog = true;
          const deactivateBusinessCard = getHttpsCallable("deactivateBusinessCard");
          let result = await deactivateBusinessCard({
            businessCardId: this.businessCardId,
            businessProfileId: this.userProfile.businessProfileId,
            isDeactivatedByBusiness: true,
          });
          //The cloud function was executed
          if (result.data.errorInfo) {
            //Encountered an error
            console.log("In the client deactivateBusinessCard then error block");
            console.log("Error: " + result.data.errorInfo.message);
            this.loadingDialog = false;
          } else {
            console.log(result.data);
            this.loadingDialog = false;
            this.snackbarText = "Team Member Deactivated Successfully!";
            this.snackbarTimeout = 5000;
            this.snackbar = true;
          }
          //End: Call a cloud function to deactivate to the selected card
        } catch (error) {
          console.log(error);
        }
      },
      async cancelInvitation() {
        await this.deleteCardholder("Deactivated");
        this.cancelInvitationDialog = false;
        this.snackbarText = "Invitation Canceled Successfully!";
        this.snackbarTimeout = 5000;
        this.snackbar = true;
      },
      async removeCardholder() {
        await this.deleteCardholder();
        this.removeCardholderDialog = false;
        this.snackbarText = "Team Member Removed Successfully!";
        this.snackbarTimeout = 5000;
        this.snackbar = true;
      },
      async reactivateCardholder(item) {
        if (this.noOfCardHolders >= this.businessProfile.noOfEmployees) {
          this.subscriptionLimitReachedDialog = true;
          return;
        }
        this.businessCardId = item.businessCardId;
        await this.updateCardholderStatus("Active");
        this.deactivateDialog = false;
        this.snackbarText = "Team Member Reactivated Successfully!";
        this.snackbarTimeout = 5000;
        this.snackbar = true;
      },
      async resendInvite(item) {
        if (
          item.status == "Deactivated" &&
          this.noOfCardHolders >= this.businessProfile.noOfEmployees
        ) {
          this.subscriptionLimitReachedDialog = true;
          return;
        }
        console.log("item: ", item);
  
        this.businessCardId = item.businessCardId;
        this.snackbarText = "Resending Invite...";
        this.snackbarTimeout = -1;
        this.snackbar = true;
        console.log("Send Invite to " + item.email);
        let functionData = {
          email: item.email,
          firstName: item.firstName,
          businessName: this.businessProfile.businessName,
          businessCardUrl: item.dynamicLink.replace(
            "https://",
            ""
          ),
        };
        const sendInvitation = getHttpsCallable("sendInvitation");
        sendInvitation(functionData)
          .then(async (result) => {
            //The cloud function was executed
            if (result.data.errorInfo) {
              //Encountered an error
              console.log("In the client then error block");
              console.log("Error: " + result.data.errorInfo.message);
            } else {
              console.log(result.data);
            }
            if (item.status != "Pending") {
              await updateBusinessCardsDoc(item.businessCardId,{ status: "Pending" });
            }
            this.snackbarText = "Invite resent successfully!";
            this.snackbarTimeout = 3000;
          })
          .catch((error) => {
            console.log("In the client then block");
            console.log("In the client catch");
            console.log(error.message);
            this.snackbarText = "Something went wrong. Please try again.";
            this.snackbarTimeout = 3000;
          });
      },
      handlehideIssueCardTooltip() {
        this.hideIssueCardTooltip = true;
        this.updateBusinessProfileDetails({
          isAddNewBusinessCardTooltipDisplayed: true,
        });
      },
      createCardIssuedReminderTriggers(businessCardId) {
        console.log("called createCardIssuedReminderTriggers");
        this.cardIssuedReminders = [];
  
        let timeSlotsInMinutes = [
          {
            message: `Card issued reminder 1`,
            mins: 2880,
            type: constants.CARD_ISSUED_REMINDER,
            templateId: "7",
          },
          {
            message: `Card issued reminder 2`,
            mins: 5760,
            type: constants.CARD_ISSUED_REMINDER,
            templateId: "8",
          },
          {
            message: `Card issued reminder 3`,
            mins: 8640,
            type: constants.CARD_ISSUED_REMINDER,
            templateId: "9",
          },
        ];
  
        timeSlotsInMinutes.forEach((item) => {
          let now = new Date();
          let timeToRun = new Date(now.setMinutes(now.getMinutes() + item.mins));
  
          this.cardIssuedReminders.push(
            new EventTrigger({
              notificationType: constants.EMAIL_NOTIFICATION,
              templateId: item.templateId,
              businessCardId: businessCardId,
              hasRun: false,
              message: item.message,
              timeToRun: timeToRun,
              type: item.type,
              timeSlotInMinutes: item.mins,
            })
          );
        });
      },
      async resendInviteBySMS(cardholder) {
  
      let businessCardUrl = cardholder.dynamicLinkForAppDownload || "";
      businessCardUrl = businessCardUrl.replace("https://", "");
  
        //Call the cloud function to send the SMS
        const sendInvitationToNewCardholderBySMS = getHttpsCallable("sendInvitationToNewCardholderBySMS");
        let result = await sendInvitationToNewCardholderBySMS({
          email: cardholder.email,
          firstName: cardholder.firstName,
          businessName: this.businessProfile.businessName,
          businessCardUrl: businessCardUrl,
          countryPhoneCodeNumber: cardholder.countryPhoneCodeNumber,
          mobile: cardholder.mobile,
        });
        //The cloud function was executed
  
        //Show snackbar
        let snackbarText = result.data.success
          ? "Invitation resent successfully!"
          : "Something went wrong, please try again";
  
        this.showSnackbar({ show: true, text: snackbarText });
      },
    },
  };
  </script>
  <style scoped>
  .device-corners {
    border-radius: 38px;
  }
  
  /*Enable user to hide issue card tooltip by clicking on "x" button. */
  .v-tooltip__content {
    pointer-events: initial;
  }
  
  /*Position the detached tooltip. */
  .issue-card-tooltip {
    top: 48% !important;
    /* left: 0px !important; */
  }
  </style>
  